import type { UIEvent } from 'react';

import { LinkWrapper } from 'components';
import { useTracking } from 'hooks';

export const ButtonBreadcrumb = ({ ...props }: { children: React.ReactNode; href: string }) => {
  const { sendDataToGTM, getFormattedTrackData } = useTracking();

  const trackClick = (event: UIEvent) => {
    const target = event.currentTarget as HTMLButtonElement;
    const getLabel = () => {
      const label = target.getAttribute('href')?.split('/').pop();

      if (label === 'departamentos') {
        return 'Inicio';
      }

      return label;
    };

    sendDataToGTM(
      getFormattedTrackData({
        event: 'event',
        category: 'geral',
        action: 'clique:breadcrumb',
        label: getLabel(),
      })
    );
  };

  return <LinkWrapper onClick={trackClick} {...props} />;
};
